import React from 'react';
import PanelActions from '../panel/action/panelActions';
import BuilderActions from '../builder/action/builderActions';
import GridStore from '../panel/store/gridStore';
import GridBlock from './block/gridBlock';
import CategoryBlock from './block/categoryBlock';
import UserBlock from './block/userBlock';
import SearchBlock from './block/searchBlock';
import MapBlock from './block/mapBlock';
import clone from 'clone';
import { findIndex, omit, sortBy } from 'underscore';
import { createHistory, useQueries } from 'history';
import UrlStore from '../urlhandler/urlHandlerStore';
import DoFilterOnData from './filterOperation';
import FilterAction from './action/filterAction';
import FilterStore from './store/filterStore';
import ToogleStore from '../urlhandler/toogleHandlerStore';
import moment from 'moment';
import './themes/reactiveTheme';
import IsotopBlock from './block/isotopeBlock';
import QuickSort from '../helper/quicksort';
import Sorting from 'sort-all-in-one';

const history = useQueries(createHistory)();
const $ = jQuery;
window.doAjax = true;
window.loadPageNumber = false;

class ShowBuilderPreview extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      // this.mergeSort = this.mergeSort.bind(this);
      this.state = {
        'previewData': this.props.previewData,
        'previewTaxonomyData': this.props.allLayout,
        'urlData': {},
        gridToggle: true,
        searchToggle: true,
        categoryToggle: true,
        mapToggle: true,
        isotopeToggle: true,
        originData: clone(this.props.previewData),
        isEditable: API.isEditable ? true : false,
      };
      API['filterable'] = this.props.settingsData.ajax === 'true' && this.props.settingsData.ajax ? 'true' : 'false';
      this.filterable = API.filterable === 'false' ? true : false;
      this.previewOptions = clone(this.state.previewData);
      this.makeFilterCall = this.makeFilterCall.bind(this);
      this.handleBlockToggle = this.handleBlockToggle.bind(this);
      this.handleFilter = this.handleFilter.bind(this);
      this.doProcessUrl = this.doProcessUrl.bind(this);
      this.filterDataOnPrequery = this.filterDataOnPrequery.bind(this);
      this.switchAdmin = this.switchAdmin.bind(this);
    }

    componentWillMount() {
      let dropdownAttributeToogle = {};
      const allLayout = clone(this.props.allLayout);
      for (const key in allLayout) {
        if (allLayout.hasOwnProperty(key)) {
          if (allLayout[key]['type'] === 'search' && allLayout[key].hasOwnProperty('searchAttr')) {
            for (let index = 0; index < allLayout[key]['searchAttr'].length; index++) {
              dropdownAttributeToogle[allLayout[key]['searchAttr'][index].uid] = false;
            }
          }
        }
      }
      this.setState({ dropdownAttributeToogle });
      this.doProcessUrl();
      this.handleFilter({}, this.props.previewData);
    }

    componentDidMount() {
      // for url handling
      history.listen((location) => {
        if (API.filterable === 'true') {
          if ('pagenumber' in location.query) {
            this.makeFilterCall(location.query, location.query.pagenumber);
          } else {
            this.makeFilterCall(location.query);
          }
        }
        if (_.isEmpty(location.query) === false) {
          this.handleFilter(location.query, this.props.previewData);
        }
      });

      GridStore.listen(this.updateData.bind(this));
      UrlStore.listen(this.updateUrlData.bind(this));
      FilterStore.listen(this.updateFilterData.bind(this));
      ToogleStore.listen(this.toggleDropdown.bind(this));

      if (this.state.isEditable) {
        $('.rebuilder').sortable({
          handle: '.builder-shortable',
          start: (e, ui) => {
            ui.placeholder.height(ui.item.height());
            ui.placeholder.width(ui.item.width());
            $(ui.item).addClass('forceBg');
          },
          delay: 150,
          stop: this.handleSort.bind(this),
          placeholder: 'ui-state-highlight',
        });
      }
    }

    componentWillReceiveProps(nextProps) {
      API['filterable'] = nextProps.settingsData.ajax === 'true' && nextProps.settingsData.ajax ? 'true' : 'false';
      let dropdownAttributeToogle = {};
      const allLayout = clone(nextProps.allLayout);
      for (const key in allLayout) {
        if (allLayout.hasOwnProperty(key)) {
          if (allLayout[key]['type'] === 'search' && allLayout[key].hasOwnProperty('searchAttr')) {
            for (let index = 0; index < allLayout[key]['searchAttr'].length; index++) {
              dropdownAttributeToogle[allLayout[key]['searchAttr'][index].uid] = false;
            }
          }
        }
      }
      this.setState({ dropdownAttributeToogle, isEditable: nextProps.isEditable });
      this.handleFilter({}, nextProps.previewData);
    }

    doProcessUrl() {
      let hash = '';
      const hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        const temp = {};
        if (hash[0].length !== 0) {
          temp.key = hash[0];
          temp.value = hash[1];
          window.searchArray.push(temp);
        }
      }
      const allLayout = clone(this.props.allLayout);
      const isSearch = findIndex(allLayout, { type: 'search' });
      if (isSearch !== -1) {
        const searchAttr = clone(allLayout[isSearch].searchAttr);
        window.searchArray.map((searchItem) => {
          const isTaxonomy = findIndex(searchAttr, { selectedTaxonomy: searchItem.key });
          const isMetakey = findIndex(searchAttr, { selectedMetakey: searchItem.key });
          if (isTaxonomy !== -1) {
            searchItem.selectedDataType = searchAttr[isTaxonomy].selectedDataType;
            searchItem.viewType = searchAttr[isTaxonomy].viewType;
            searchItem.title = searchAttr[isTaxonomy].title;
            if (searchItem.viewType === 'combobox') {
              searchItem.linearData = this.props.helperData.terms[searchItem.key].linear;
            }
          } else if (isMetakey !== -1 && searchItem.key.search('[min]') === -1 && searchItem.key.search('[start]')) {
            searchItem.selectedDataType = searchAttr[isMetakey].selectedDataType;
            searchItem.viewType = searchAttr[isMetakey].viewType;
            searchItem.title = searchAttr[isMetakey].title;
            searchItem.metakey = searchAttr[isMetakey].selectedMetakey;
          } else {
            // will work for range and daterange
            const key = 'key';
            const isDateRangeStart = searchItem[key].indexOf('[start]');
            const isDateRangeEnd = searchItem[key].indexOf('[end]');
            const isRangeMin = searchItem[key].indexOf('[min]');
            const isRangeMax = searchItem[key].indexOf('[max]');
            if (isDateRangeStart !== -1) {
              const dateStartMetakey = searchItem[key].split('[start]').length ? searchItem[key].split('[start]')[0] : null;
              const index = findIndex(searchAttr, { selectedMetakey: dateStartMetakey });
              searchItem.selectedDataType = searchAttr[index].selectedDataType;
              searchItem.viewType = searchAttr[index].viewType;
              searchItem.title = searchAttr[index].title;
              searchItem.metakey = dateStartMetakey;
              searchItem.key = searchItem[key];
            } else if (isDateRangeEnd !== -1) {
              const dateEndmetakey = searchItem[key].split('[end]').length ? searchItem[key].split('[end]')[0] : null;
              const index = findIndex(searchAttr, { selectedMetakey: dateEndmetakey });
              searchItem.selectedDataType = searchAttr[index].selectedDataType;
              searchItem.viewType = searchAttr[index].viewType;
              searchItem.title = searchAttr[index].title;
              searchItem.metakey = dateEndmetakey;
              searchItem.key = searchItem[key];
            } else if (isRangeMin !== -1) {
              const rangeMinMetakey = searchItem[key].split('[min]').length ? searchItem[key].split('[min]')[0] : null;
              const indexforRangeMin = findIndex(searchAttr, { selectedMetakey: rangeMinMetakey });
              searchItem.selectedDataType = searchAttr[indexforRangeMin].selectedDataType;
              searchItem.viewType = searchAttr[indexforRangeMin].viewType;
              searchItem.title = searchAttr[indexforRangeMin].title;
              searchItem.metakey = rangeMinMetakey;
              searchItem.key = searchItem[key];
            } else if (isRangeMax !== -1) {
              const rangeMaxMetakey = searchItem[key].split('[max]').length ? searchItem[key].split('[max]')[0] : null;
              const indexRangeMin = findIndex(searchAttr, { selectedMetakey: rangeMaxMetakey });
              searchItem.selectedDataType = searchAttr[indexRangeMin].selectedDataType;
              searchItem.viewType = searchAttr[indexRangeMin].viewType;
              searchItem.title = searchAttr[indexRangeMin].title;
              searchItem.metakey = rangeMaxMetakey;
              searchItem.key = searchItem[key];
            }
          }
        });
      }
    }


    updateUrlData(urlData) {
      if (API.filterable === 'true') {
        if ('pagenumber' in urlData.query) {
          this.makeFilterCall(urlData.query, urlData.query.pagenumber);
        } else {
          this.makeFilterCall(urlData.query);
        }
      }
      if (_.isEmpty(urlData) === false) {
        this.handleFilter(urlData.query, this.state.previewData);
      }
    }

    handleFilter(urlData, previewData) {
      const self = this;
      let previewOptions = {};
      this.availableData = clone(previewData.data);
      this.filterTermData = [];
      if (_.isEmpty(urlData) || API.filterable === 'false' || API.filterable === false) {
        previewOptions = clone(previewData);
        // console.log(previewOptions);
      }
      let totalNumberOfPosts = previewOptions.total_post ? previewOptions.total_post : 0;

      if (this.filterable) {
        const defaultProps = {};
        defaultProps.metakey = this.metakey;
        defaultProps.urlData = urlData;
        defaultProps.filterTermData = this.filterTermData;
        defaultProps.availableData = this.availableData;
        defaultProps.props = this.props;
        const doFilterOnData = new DoFilterOnData(defaultProps);
        previewOptions.data = doFilterOnData.filterOperation();
        if (previewOptions.data !== undefined) {
          totalNumberOfPosts = previewOptions.data.length;
        }
      }

      if (urlData.location) {
        this.filterDataForMapSearch(urlData.location, previewOptions.data).then((res) => {
          previewOptions.data = res;
          self.setState({
            urlData,
            previewOptions,
            totalNumberOfPosts: res.length,
            'previewData': clone(previewData),
          });
        });
      } else {
        this.setState({
          urlData,
          previewOptions,
          totalNumberOfPosts,
          'previewData': clone(previewData),
        });
      }
    }

    // very handy stuff
    getLocation(components, type) {
      let result = '';
      components.forEach((address) => {
        if (address.types.indexOf(type) !== -1) {
          result = address;
        }
      });
      return result;
    }


    compareLocation(geocode, location, item, distance) {
      if (geocode[0].types.indexOf('country') !== -1 && geocode[0].types.indexOf('political') !== -1) {
        // location is country name
        const country = this.getLocation(geocode[0].address_components, 'country');
        if (item.meta.country === country.long_name) {
          return item;
        }
      } else {
        let searchRadious = 100;
        const allLayout = clone(this.props.allLayout);
        const indexOfSearch = findIndex(allLayout, {type: 'search'});
        if (indexOfSearch !== -1) {
          const indexOfLocation = findIndex(allLayout[indexOfSearch].searchAttr, {viewType: 'mapsearch' });
          if (allLayout[indexOfSearch].searchAttr[indexOfLocation].hasOwnProperty('mapradious')) {
            searchRadious = parseInt(allLayout[indexOfSearch].searchAttr[indexOfLocation]['mapradious'], 10);
          }
        }
        if (distance < searchRadious * 1000) { // searchRadious is converted to meter form kilo meter
          return item;
        }
      }
      return false;
    }

    filterDataForMapSearch(value, availableData) {
      let filteredData = [];
      const geocoder = new google.maps.Geocoder();
      let latitude = null;
      let longitude = null;

      return new Promise((resolve) => {
        geocoder.geocode({ 'address': value }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            latitude = results[0].geometry.location.lat();
            longitude = results[0].geometry.location.lng();
            const origin = new google.maps.LatLng(latitude, longitude);
            // console.log(availableData);
            availableData.map((item) => {
              if (item.meta.hasOwnProperty('latitude') && item.meta.hasOwnProperty('longitude')) {
                // console.log(item.meta.latitude);
                const destination = new google.maps.LatLng(parseFloat(item.meta.latitude), parseFloat(item.meta.longitude));
                const distance = google.maps.geometry.spherical.computeDistanceBetween(origin, destination);
                const data = this.compareLocation(results, value, item, distance); // country, city
                if (data !== false) {
                  data.distance = distance;
                  filteredData.push(data);
                }
              }
            });
            let newArray = [];
            if (filteredData.length !== 0) {
              const opts = {
                  algo: 'bubble',   // bubble,selection,insertion,quick,merge
                  array: filteredData,
                  key: 'distance',
                  orderBy: 'asc',      // asc,desc
                  date: false,     // if the key is a date or false if not
                },
                mySorting = new Sorting();
              newArray = mySorting.sort(opts);
            }
            resolve(newArray);
          }
        });
      });
    }

    handleBlockToggle(type) {
      const self = this;
      switch (type) {
        case 'grid':
          self.setState({ gridToggle: !self.state.gridToggle });
          break;
        case 'search':
          self.setState({ searchToggle: !self.state.searchToggle });
          break;
        case 'category':
          self.setState({ categoryToggle: !self.state.categoryToggle });
          break;
        case 'map':
          self.setState({ mapToggle: !self.state.mapToggle });
          break;
        case 'isotope':
          self.setState({ isotopeToggle: !self.state.isotopeToggle });
          break;
        default:
          break;
      }
    }
    makeFilterCall(query, pageNumber = '1', sortData = {}) {
      const search_stack = clone(window.searchArray);
      const post_type = this.props.settingsData.post_type ? this.props.settingsData.post_type : 'post';
      let numberOfPosts = '10';
      this.props.allLayout.forEach((layout) => {
        if ('numberOfPosts' in layout) {
          numberOfPosts = layout.numberOfPosts;
        }
      });
      const rangekeys = [];
      // need to check in searchArray
      search_stack.forEach((stack, index) => {
        if (index + 1 < search_stack.length && stack.key.search('[min]') !== -1
          && stack.key.search('[start]') !== -1
          && stack.key !== 'pagenumber'
          && stack.key !== 'search_item'
          && stack.key !== 'view') {
          if (stack.key.indexOf('[start]') !== -1) {
            if (search_stack[index].metakey === search_stack[index + 1].metakey) {
              rangekeys.push({
                ...stack,
                metakey: search_stack[index].metakey,
                values: [moment(search_stack[index].value).unix(), moment(search_stack[index + 1]).unix()],
              });
            }
          } else {
            if (search_stack[index].metakey === search_stack[index + 1].metakey) {
              rangekeys.push({
                ...stack,
                metakey: search_stack[index].metakey,
                values: [search_stack[index].value, search_stack[index + 1].value],
              });
            }
          }
        }
      });
      if (window.doAjax === true) {
        FilterAction.pushForFilter({
          post_type,
          numberOfPosts,
          pageNumber,
          url_data: omit(query, 'pagenumber', 'view', 'oldviewvalue'),
          search_stack,
          rangekeys,
          sortData,
        });
      }
    }
    handleSort(event, ui) {
      $(ui.item).removeClass('forceBg');
      const oldLayout = clone(this.props.allLayout);
      const allLayout = [];
      $(event.target).children().each((index, item) => {
        const uid = String($(item).data('uid'));
        const findKey = findIndex(oldLayout, { uid });
        if (findKey !== -1) {
          allLayout.push({ ...oldLayout[findKey], position: index + 1 });
        }
      });
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
        'return': 'dont',
      };
      BuilderActions.saveAllBlocks(pushLayout);
    }
    handleAsyncSorting(sortData) {
      this.makeFilterCall(this.state.urlData, '', sortData);
    }

    handleChangePagination(pageNumber) {
      this.makeFilterCall(this.state.urlData, pageNumber);
    }

    updateData(builderData) {
      const key = this.props.shortcodeKey;
      if (builderData.hasOwnProperty(key)) {
        this.setState({
          'previewData': builderData[key].previewData,
        });
      }
    }
    updateFilterData(result) {
      $('#LoadTime').fadeOut(100);
      this.setState({
        previewOptions: result.posts,
        totalNumberOfPosts: result.posts.total_post,
      });
    }
    toggleDropdown(field) {
      const dropdownAttributeToogle = clone(this.state.dropdownAttributeToogle);
      for (const key in dropdownAttributeToogle) {
        if (dropdownAttributeToogle.hasOwnProperty(key)) {
          if (field === key) {
            dropdownAttributeToogle[key] = !dropdownAttributeToogle[key];
          } else {
            dropdownAttributeToogle[key] = false;
          }
        }
      }
      this.setState({ dropdownAttributeToogle });
    }
    showPanel(panelType, uid, e) {
      e.preventDefault();
      PanelActions.togglePanel(panelType, this.props.shortcodeKey, uid);
    }
    deleteBlock(uid, e) {
      e.preventDefault();
      const layouts = this.props.allLayout;
      const key = findIndex(layouts, { uid });  // object shorthand
      if (key !== -1) {
        layouts.splice(key, 1);
      }
      const pushBlock = {
        'allLayout': layouts,
        'shortcodeKey': this.props.shortcodeKey,
      };
      PanelActions.togglePanel('', this.props.shortcodeKey);
      BuilderActions.saveAllBlocks(pushBlock);
    }
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    filterDataOnPrequery(allData) {
      let selectedTaxonomy = [];
      let filteredData = [];
      let prequeryOption = null;
      if (this.props.settingsData.hasOwnProperty('prequery')) {
        if (this.props.settingsData.prequery.hasOwnProperty('taxonomy')) {
          selectedTaxonomy = clone(this.props.settingsData['prequery']['taxonomy']);
        }
        if (this.props.settingsData.prequery.hasOwnProperty('defaultPrequery')) {
          prequeryOption = this.props.settingsData['prequery']['defaultPrequery'];
        }
      }
      allData.data.map((item) => {
        const terms = clone(item.terms);
        let takenastaxonomy = false;
        for (const key in terms) {
          if (terms.hasOwnProperty(key)) {
            const result = _.intersection(terms[key], selectedTaxonomy);
            if (result.length) {
              takenastaxonomy = true;
            }
          }
        }
        if (takenastaxonomy === true) {
          filteredData.push(item);
        }
      });
      if (selectedTaxonomy.length === 0) {
        filteredData = allData.data;
      }
      if (prequeryOption !== null) {
        const partialPrequryOptions = prequeryOption.split('-');
        const base = partialPrequryOptions[0];
        const type = partialPrequryOptions[1];
        switch (base) {
          case 'popular':
            // this.mergeSort(filteredData, 0, filteredData.length);
            const quickSortPopular = new QuickSort({ key: 'comment_count', type });
            filteredData = quickSortPopular.startSorting(filteredData);
            break;
          case 'date':
            const quickSortDate = new QuickSort({ key: 'post_date', type });
            filteredData = quickSortDate.startSorting(filteredData);
            break;
          case 'title':
            const quickSortTitle = new QuickSort({ key: 'post_title', type });
            filteredData = quickSortTitle.startSorting(filteredData);
            break;
          default:
            break;
        }
      }
      return filteredData;
    }
    switchAdmin(e) {
      const flag = this.state.isEditable;
      this.setState({ isEditable: !flag });
      e.preventDefault();
    }
    render() {
      const self = this;
      let { previewOptions, totalNumberOfPosts } = this.state;
      const windowUrlData = clone(window.searchArray);
      let { allLayout } = this.props;
      if (allLayout.length) {
        allLayout = sortBy(allLayout, 'position', 'asc');
      }
      let searchUrl = 0;
      for (let index = 0; index < windowUrlData.length; index++) {
        if (windowUrlData[index].key !== 'pagenumber') {
          searchUrl++;
        }
      }
      let data = [];
      if (searchUrl === 0) {
        data = this.filterDataOnPrequery(previewOptions);
        // previewOptions.data = clone(data);
        // totalNumberOfPosts = data.length;
      }
      const gridViewIndex = findIndex(windowUrlData, { key: 'view' });
      let view = 'grid';
      if (gridViewIndex !== -1) {
        view = windowUrlData[gridViewIndex].value;
      }
      const showAllBlock = (block, index) => {
        let blockClass;
        switch (block.layout) {
          default:
            blockClass = 'flex-md-' + block.layout + ' ' + 'flex-xs-12';
            break;
        }
        let customClassName = null;
        switch (block.type) {
          case 'grid':
            customClassName = !this.state.gridToggle ? 'active' : '';
            break;
          case 'category':
            customClassName = !this.state.categoryToggle ? 'active' : '';
            break;
          case 'search':
            customClassName = !this.state.searchToggle ? 'active' : '';
            break;
          case 'map':
            customClassName = !this.state.mapToggle ? 'active' : '';
            break;
          case 'isotope':
            customClassName = !this.state.isotopeToggle ? 'active' : '';
            break;
          default:
            break;
        }
        const isEditableClass = this.state.isEditable ? 'single-block' : 'preview-block';
        return (<div key={'showBuilder-' + index} className={ 'reblock ' + blockClass} data-uid={block.uid} >
          <div className={isEditableClass}>
            <div className="child-block-handle rq-main-sorting-block">

              { this.state.isEditable ? <div className="block-edit-button" style={{ paddingRight: 30 + 'px' }}>
                {
                  block.type === 'search' ? <a className="edit-button" href="#" onClick={self.showPanel.bind(self, 'advancedsearch', block.uid)} data-toggle="tooltip" data-placement="top" title={API.LANG.TOOL_TIP_SEARCH_SETTINGS}>
                  <i className="fa fa-pencil"></i>
                </a>
                :
                <a className="edit-button" href="#" onClick={self.showPanel.bind(self, block.type, block.uid)} data-toggle="tooltip" data-placement="top" title={API.LANG.TOOL_TIP_BLOCK_PANEL}>
                  <i className="fa fa-pencil"></i>
                </a>
                }

                <div className="hidden-button-block">
                  <div>
                    <a href="#" onClick={self.deleteBlock.bind(self, block.uid)}>
                      <i className="fa fa-times"></i>
                    </a>
                  </div>
                </div>
              </div> : null }
            { this.state.isEditable ? <a href="#" className="builder-shortable">
              <i className="fa fa-bars"></i>
            </a> : null }
            { this.state.isEditable && <label style={ { marginLeft: '30px' } }>{this.capitalize(block.type)}</label> }
            {this.state.isEditable && <button className={'panel-toggle-button' + ' ' + customClassName} onClick={this.handleBlockToggle.bind(this, block.type)} data-toggle="tooltip" data-placement="top" title={API.LANG.TOOL_TIP_TOGGLE}><i className="fa fa-chevron-down"></i></button>}
            {this.state.isEditable && <div>
                {
                  block.type === 'search' ? <div className="search-panel-edit-button">
                  <a href="#" onClick={self.showPanel.bind(self, block.type, block.uid)} data-toggle="tooltip" data-placement="top" title={API.LANG.TOOL_TIP_SEARCH_ADD}>
                    <i className="fa fa-plus"></i>
                  </a>
                </div> : null
                }
              </div>
            }

          </div>
          <div>
            { block.type === 'grid' && 'data' in this.state.previewData && previewOptions
             ? <div className={view === 'grid' ? block.gridWrapperClass : block.listWrapperClass}>
                <GridBlock urlData={this.state.urlData} {...this.props}
                  block={block} uid={block.uid}
                  previewOption={searchUrl !== 0 ? previewOptions : { data: data }}
                  total={totalNumberOfPosts}
                  isToggle={this.state.gridToggle}
                  onChangePagination={this.handleChangePagination.bind(this)}
                  onSortChange={this.handleAsyncSorting.bind(this)}
                />
               </div> :
              null }

            { block.type === 'isotope' && 'data' in this.state.previewData && this.previewOptions
             ? <div>
                <IsotopBlock {...this.props}
                  previewData={this.props.previewData}
                  previewOptions={previewOptions}
                  isToggle={this.state.isotopeToggle}
                  block={block} />
             </div> :
              null }


            { block.type === 'search' && block.searchAttr ?
              <div className={block.customCssClass}>
                <SearchBlock
                  {...this.props}
                  previewData={previewOptions}
                  isToggle={this.state.searchToggle}
                  urlData={this.state.urlData}
                  uid={block.uid}
                  searchAttr={block.searchAttr}
                  dropdonwtoggle={this.state.dropdownAttributeToogle}
                  isEditable={this.state.isEditable}
                />
              </div>
            : null }

            { block.type === 'category' ?
              <div className={block.categorySettings !== undefined ? block.categorySettings.categoryWrapperClass : ''}>
                <CategoryBlock
                  {...this.props}
                  isToggle={this.state.categoryToggle}
                  block={block}
                />
              </div> :
              null }

            { block.type === 'map' ?
              <div className={block.mapWrapperClass}>
                <MapBlock
                  {...this.props}
                  block={block}
                  isToggle={this.state.mapToggle}
                  previewOption={previewOptions}
                />
              </div> :
              null }

          </div>
        </div>
      </div>);
      };

      return (<div className=" rq-reactive-builder flex-row rebuilder">
        { allLayout.length ? allLayout.map(showAllBlock) : null }
      </div>);
    }
}

ShowBuilderPreview.propTypes = {
  'allLayout': React.PropTypes.array,
  'previewData': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'settingsData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default ShowBuilderPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/showBuilderPreview.js
 **/